/*
 * @author: yanhoup
 * @description: OBKoro1
 */
/**
 * @author: yanhoup
 * @description: RangePicker抛出的数组转换成想要的字段
 */

import moment from 'moment';

/**
 * @param originName
 * @param newNames
 * @param formData
 * @param format
 * @returns object
 * @example tranformRangeTime('createTime', ['createTime', 'endTime'], form)
 */
const tranformRangeTime = (originName: string, newNames: string[], formData: any, format = 'YYYY-MM-DD') => {
  let newData = { ...formData };
  if (formData[originName]) {
    newData = {
      ...formData,
      [newNames[0]]: formData[originName] && formData[originName][0] ? moment(formData[originName][0]).valueOf() : '',
      [newNames[1]]: formData[originName] && formData[originName][1] ? moment(formData[originName][1]).valueOf() : '',
    };
  }
  delete newData[originName];
  return newData;
};

export { tranformRangeTime };
